<template>
  <b-modal
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    v-model="show"
    @close="closeModal"
    class="pa-4"
    :style="'width: 708px !important;'"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Send Request</h3>
    </template>
    <b-card
      no-body
      v-cloak
      class="rounded-0 border-0 mx-0 bg-light"
      @drop.prevent=""
      @dragover.prevent
    >
      <b-form @submit.prevent="sendRequest">
        <b-card-text :style="'opacity: 1;'">
          <h6 class="font-weight-bold">Select recipients to request a file</h6>
          <b-form-input
            v-model="userSearch"
            placeholder="Search by name or email..."
            class="mb-2"
          />
          <div class="border rounded p-2">
            <div
              v-if="companyTradiesLoading"
              class="text-center text-muted py-2"
            >
              Loading...
            </div>
            <div
              v-else-if="paginatedTradies.length === 0"
              class="text-muted py-2 pl-1"
            >
              No users found
            </div>
            <div
              v-for="t in paginatedTradies"
              :key="t.id"
              class="d-flex align-items-center w-100 send-request-row"
              :id="'tooltip-target-' + t.id"
            >
              <b-form-checkbox
                v-if="t.can_access"
                :value="t.email"
                v-model="form.emails"
                class="send-request-checkbox"
              >
                &nbsp;
              </b-form-checkbox>

              <span
                v-else
                class="send-request-checkbox d-flex align-items-center"
                style="padding-left: 4.3px"
              >
                <b-icon-lock />
              </span>

              <span
                class="send-request-label"
                :class="{ 'text-muted': !t.can_access }"
              >
                {{ (t.full_name && t.full_name.trim()) || t.email || '' }}
                <!-- || t.email }}> -->
                <!-- <small class="text-muted ml-1">{{ t.email }}</small> -->
              </span>
              <b-tooltip
                :target="'tooltip-target-' + t.id"
                triggers="hover"
                delay="0"
              >
                <div v-if="!t.can_access">Locked - Assign token to view</div>
              </b-tooltip>
            </div>
          </div>
        </b-card-text>

        <div>
          <b-pagination
            v-if="tradieRows > perPage"
            v-model="tradiePage"
            :total-rows="tradieRows"
            :per-page="perPage"
            align="center"
            hide-goto-end-buttons
          />
        </div>

        <div v-if="template">
          <h3 class="font-weight-bold mt-4">Add due date</h3>
          <b-form-datepicker
            id="input-date"
            type="date"
            locale="en-AU"
            today-button
            reset-button
            no-flip
            :show-decade-nav="true"
            placeholder="dd/mm/yyyy"
            aria-describedby="input-date-feedback"
            v-model="form.due_date"
            :min="minDueDate"
            :date-format-options="{
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }"
            @input="onDateChanged"
          />
          <span class="invalid-feedback d-block">
            {{ dateInvalid }}
          </span>

          <h3 class="font-weight-bold mt-4">Add instruction</h3>
          <b-form-textarea
            id="input-title"
            type="text"
            v-model="form.instruction"
            required
            placeholder="Instructions"
            class="font-weight-normal mb-2"
            rows="5"
          ></b-form-textarea>
        </div>
        <div class="my-4 mx-0">
          <b-container>
            <b-row>
              <b-col cols="12" md="5" class="mb-md-4 mb-3">
                <b-button
                  class="w-100 btn-outlined bg-white text-dark"
                  variant="outline-secondary"
                  :style="'height: 64px !important;'"
                  :disabled="loading"
                  @click="clear"
                >
                  Clear
                </b-button>
              </b-col>
              <b-col cols="12" md="2" class="mb-0"></b-col>
              <b-col cols="12" md="5" class="mb-md-4 mb-3">
                <!-- prettier-ignore -->
                <b-button
                  type="submit"
                  class="w-100 h-auto float-right py-3"
                  variant="primary"
                  :style="'height: 64px !important;'"
                  :loading="loading"
                  :disabled="loading || !form.emails.length || dateInvalid != null"
                >
                  Send
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-form>

      <b-modal v-model="showDuplicateConfirm" centered size="md">
        <template #modal-title>
          <h3 class="font-weight-bold">{{ duplicateLabel }} already on file</h3>
        </template>

        <b-row class="mb-3">
          <b-col>
            {{
              duplicateHits.length === 1
                ? 'This tradie already has'
                : 'These tradies already have'
            }}
            a <strong>{{ duplicateLabel }}</strong> file. View
            {{ duplicateHits.length === 1 ? 'it' : 'them' }}, or request anyway.
          </b-col>
        </b-row>

        <div v-for="hit in duplicateHits" :key="hit.email" class="mb-3">
          <h5 v-if="duplicateHits.length > 1" class="font-weight-bold mb-2">
            {{ hit.name }}
          </h5>
          <existing-file-list
            :files="hit.files"
            show-company-approval
            view-only
            @view="onViewDuplicateFile"
          />
        </div>

        <template #modal-footer>
          <div class="d-flex flex-column w-100" style="gap: 16px">
            <b-button
              block
              class="m-0 btn-outlined bg-white text-dark"
              variant="outline-secondary"
              @click="requestAnyway"
            >
              Request anyway
            </b-button>
            <b-button
              v-if="duplicateHits.length < form.emails.length"
              block
              class="m-0 btn-outlined bg-white text-dark"
              variant="outline-secondary"
              @click="skipDuplicates"
            >
              Skip {{ duplicateHits.length === 1 ? 'them' : 'those tradies' }}
            </b-button>
          </div>
        </template>
      </b-modal>
    </b-card>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import Form from '@/utils/form'
import { isNil, debounce } from 'lodash'
import { matchFilesForTemplate } from '@/utils/fileMatch'
import ExistingFileList from '@/components/lists/ExistingFileList'

export default {
  name: 'SendRequestModal',

  components: {
    ExistingFileList,
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    request: {
      type: Object,
      default: null,
    },

    template: {
      type: Object,
      default: null,
    },

    formType: {
      type: String,
      default: 'add',
    },
  },

  data() {
    return {
      loading: false,
      form: new Form({
        name: '',
        uploadType: null,
        due_date: null,
        instruction: null,
        template_id: null,
        information_types: null,
        emails: [],
      }),
      validTags: [],
      invalidTags: [],
      maxTags: [],
      tagErrors: {
        message: null,
        error_code: null,
      },
      search: '',
      selectedInfoTypes: [],
      dateInvalid: null,

      companyTradies: [],
      companyTradiesMeta: null,
      companyTradiesLoading: false,
      userSearch: '',

      tradiePage: 1,
      perPage: 10,

      // email -> { id, name } for every roster row seen so far, so a recipient
      // picked on an earlier page can still be looked up when sending.
      tradiesByEmail: {},
      // Already-have-this-file warning (template requests only).
      showDuplicateConfirm: false,
      duplicateHits: [],
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      fileRequest: (state) => state.requests.request,
    }),

    minDueDate() {
      // returns local "today" as YYYY-MM-DD (safe for AU timezone)
      const d = new Date()
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },
    userSubcEmailLimit() {
      let limit = 0

      if (this.isTradieUser) {
        if (this.user.is_subscribed) {
          limit = 5
        } else {
          limit = 1
        }
      } else {
        if (this.user.is_subscribed) {
          limit = 50
        } else {
          limit = 5
        }
      }

      return limit
    },
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.$emit('closeModal')
      },
    },

    // Name/email search and pagination are both server-side (see
    // fetchCompanyTradies) — companies/tradies caps its payload at 100 rows, so
    // filtering the fetched page in the browser silently hid anyone past the
    // first 100 of the roster. companyTradies already holds just the current
    // page; only the token-holders-first sort stays client-side, applied within
    // that page.
    paginatedTradies() {
      return [...this.companyTradies].sort((a, b) => {
        if (a.can_access && !b.can_access) return -1
        if (!a.can_access && b.can_access) return 1
        return 0
      })
    },

    // Callers pass the template as { id, name } (templates page) or
    // { id, label }.
    duplicateLabel() {
      const t = this.template
      return (t && (t.label || t.name)) || 'file'
    },

    tradieRows() {
      return this.companyTradiesMeta && this.companyTradiesMeta.total != null
        ? this.companyTradiesMeta.total
        : this.companyTradies.length
    },
  },

  methods: {
    closeModal() {
      this.clear()
      this.$emit('closeModal')
    },
    clearSendRequestEmails() {
      this.form.$reset()
    },
    clearSendRequestErrrorEmails() {
      this.invalidTags = []
      this.maxTags = []
      this.tagErrors = {
        message: null,
        error_code: null,
      }
    },
    clear() {
      this.clearSendRequestEmails()
      this.clearSendRequestErrrorEmails()
    },
    checkInvalidTag(tag) {
      return this.invalidTags.includes(tag)
    },
    checkExcessTag(tag) {
      return this.maxTags.includes(tag)
    },

    // method to check if the selected date is earlier that todays date.
    isPastDate(yyyyMmDd) {
      if (!yyyyMmDd) {
        return true
      }
      const selected = new Date(yyyyMmDd + 'T00:00:00')
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return selected < today
    },

    /**
     * Recipients who already have a file of this template's type, scoped the
     * way the tradie page is (the tradie's public files plus this company's
     * own, never another business's private ones — companies/tradie/:id).
     * Archived files don't count. A failed lookup counts as "no match" so it
     * never blocks sending.
     */
    async findRecipientsWithFile() {
      const template = {
        id: this.template.id,
        label: this.duplicateLabel,
      }

      const results = await Promise.all(
        this.form.emails.map(async (email) => {
          const tradie = this.tradiesByEmail[email]
          if (!tradie) return null
          try {
            const { data } = await this.$api.get(
              `companies/tradie/${tradie.id}`,
            )
            const files = ((data && data.files) || []).filter(
              (f) => f && f.company_approval !== 'not_applicable',
            )
            const matches = matchFilesForTemplate(files, template)
            if (!matches.length) return null
            return { email, name: tradie.name, files: matches }
          } catch (e) {
            return null
          }
        }),
      )

      return results.filter(Boolean)
    },

    // Opens in a new tab so the half-filled request isn't lost.
    onViewDuplicateFile(file) {
      const id = file.file_id ? file.file_id : file.id
      const { href } = this.$router.resolve({
        name: 'file.view-page',
        params: { id },
      })
      window.open(href, '_blank')
    },

    requestAnyway() {
      this.showDuplicateConfirm = false
      this.sendRequest({ skipDuplicateCheck: true })
    },

    skipDuplicates() {
      const skip = this.duplicateHits.map((h) => h.email)
      this.form.emails = this.form.emails.filter((e) => !skip.includes(e))
      this.showDuplicateConfirm = false
      this.sendRequest({ skipDuplicateCheck: true })
    },

    async sendRequest(options) {
      if (this.request === null && this.form.due_date === null) {
        this.dateInvalid = 'Please input a valid date'
        return
      }

      // Prevents Back Dating if request is sent with an older date
      if (this.form.due_date && this.isPastDate(this.form.due_date)) {
        this.dateInvalid = 'Due date must be today or later'
        return
      }

      // The form's submit handler passes the event here, so only an explicit
      // flag skips the warning.
      const skipCheck = !!(options && options.skipDuplicateCheck === true)
      if (this.template && this.formType !== 'edit' && !skipCheck) {
        this.loading = true
        let hits = []
        try {
          hits = await this.findRecipientsWithFile()
        } finally {
          this.loading = false
        }
        if (hits.length) {
          this.duplicateHits = hits
          this.showDuplicateConfirm = true
          return
        }
      }

      this.dateInvalid = null
      this.loading = true
      this.form.$busy = true

      if (!this.template) {
        const [year, month, day] = this.request.due_date.split('-')
        this.form.name = this.request.name
        this.form.uploadType = this.request.uploadType
        this.form.due_date = `${day}/${month}/${year}`
        this.form.instruction = this.request.instruction
        this.form.information_types = this.request.information_types
      } else {
        const [year, month, day] = this.form.due_date.split('-')
        const formattedDate = `${day}/${month}/${year}`

        this.form.name = this.template.name
        this.form.template_id = this.template.id
        this.form.due_date = formattedDate
      }

      if (this.formType === 'edit') {
        await this.$api
          .put(`file-request/${this.fileRequest.id}`, this.form.$data())
          .then((res) => {
            if (!isNil(res.data.data.invalid)) {
              if (res.data.data.invalid.length) {
                this.invalidTags = res.data.data.invalid
                this.tagErrors.message =
                  'Unable to request files from the highlighted email address(es) as they are not registered users on our platform. Please remove them to proceed.'
              }
            }

            if (isNil(res.data.data.invalid)) {
              this.$emit('sendRequestResponse', res.data)
              this.clear()
              this.closeModal()
            }
          })
          .catch((error) => {
            this.form.$handleError(error)

            if (!isNil(error.response.data)) {
              this.tagErrors.error_code = error.response.data.error_code
              this.tagErrors.message = error.response.data.message
            }
          })
          .finally(() => {
            this.loading = false
            this.form.$busy = false
          })
      } else {
        await this.$api
          .post('file-request', this.form.$data())
          .then((res) => {
            if (res.data.data.invalid.length) {
              this.invalidTags = res.data.data.invalid
              this.tagErrors.message =
                'Unable to request files from the highlighted email address(es) as they are not registered users on our platform. Please remove them to proceed.'
            }

            // if (res.data.data.max.length) {
            //   this.maxTags = res.data.data.max
            //   this.tagErrors.message =
            //     'Max file sharing capacity or Max Business Admin email address share limit'
            // }

            // if (!res.data.data.invalid.length && !res.data.data.max.length) {
            //   this.$emit('sendRequestResponse', res)
            //   this.clear()
            //   this.closeModal()
            // }

            if (!res.data.data.invalid.length) {
              this.$emit('sendRequestResponse', res.data)
              this.clear()
              this.closeModal()
            }
          })
          .catch((error) => {
            this.form.$handleError(error)

            this.tagErrors.error_code = error.response.data.error_code
            if (error.response.data.message.includes('must be a valid email')) {
              this.tagErrors.message =
                'The highlighted emails must be valid email addresses. Please remove to proceed'
            } else {
              this.tagErrors.message = error.response.data.message
            }
          })
          .finally(() => {
            this.loading = false
            this.form.$busy = false
          })
      }
    },

    onDateChanged() {
      this.dateInvalid = null
    },

    setEditFormEmails() {
      if (this.formType === 'edit') {
        this.form.emails = this.form.emails.concat(this.request.emails)
      }
    },

    async fetchCompanyTradies(page = 1) {
      this.companyTradiesLoading = true

      try {
        const params = new URLSearchParams({
          limit: String(this.perPage),
          page: String(page),
          search: (this.userSearch || '').trim(),
          archived_only: 'false',
        })
        const { data } = await this.$api.get(
          `companies/tradies?${params.toString()}`,
        )

        this.companyTradies = Array.isArray(data.data) ? data.data : []
        this.companyTradiesMeta = data.meta || null
        this.companyTradies.forEach((t) => {
          if (t && t.email) {
            this.tradiesByEmail[t.email] = {
              id: t.id,
              name: (t.full_name && t.full_name.trim()) || t.email,
            }
          }
        })
      } catch (e) {
        this.companyTradies = []
        this.companyTradiesMeta = null
      } finally {
        this.companyTradiesLoading = false
      }
    },

    resetState() {
      this.userSearch = ''
      this.tradiePage = 1
      this.companyTradies = []
      this.companyTradiesMeta = null
    },
  },

  created() {
    // Debounce the keystroke -> server refetch. Resetting to page 1 goes
    // through the tradiePage watcher unless we're already there.
    this.queueTradieSearch = debounce(() => {
      if (this.tradiePage !== 1) {
        this.tradiePage = 1
      } else {
        this.fetchCompanyTradies(1)
      }
    }, 300)
  },

  beforeDestroy() {
    if (this.queueTradieSearch) this.queueTradieSearch.cancel()
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.userSearch = ''
        this.tradiePage = 1
        this.companyTradiesMeta = null
        this.setEditFormEmails()
        this.fetchCompanyTradies(1)
      }
    },
    userSearch() {
      if (!this.show) return
      this.queueTradieSearch()
    },
    tradiePage(newVal) {
      if (!this.show) return
      this.fetchCompanyTradies(newVal)
    },
  },
}
</script>

<style lang="scss" scoped>
.badge-secondary {
  color: #364052;
  background: #e8eaed;
}

/deep/ .border-gray {
  border-color: #e5e5e5;
}

/deep/ .b-form-tags {
  overflow: auto;
}

/deep/ .b-form-tags-button {
  display: none;
}

/deep/ #input-date__value_ {
  align-content: center;
}

.request-label {
  flex: 1;
  padding-left: 16px;
  text-align: left;
}

.request-label {
  flex: 1;
  padding-left: 16px;
  text-align: left;
}

.lock-icon {
  width: 450px; /* makes icon smaller — adjust to taste */
  height: auto;
  margin-bottom: 6px; /* small gap between icon and text */
}

.send-request-row {
  padding: 2px 0;
}

.send-request-checkbox {
  margin: 0 10px;
  width: 28px;
  min-width: 28px;
}

.send-request-label {
  flex: 1;
  min-width: 0;
  padding-left: 16px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.send-request-checkbox /deep/ .custom-control-input {
  top: 50%;
  transform: translateY(-50%);
}

.send-request-checkbox /deep/ .custom-control-label::before,
.send-request-checkbox /deep/ .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
}

::v-deep .b-tooltip .tooltip-inner {
  background-color: rgb(255, 255, 255);
  color: #131212;
  font-size: 1.07rem; /* default is ~0.75rem, increase to taste */
  padding: 8px 12px; /* default is ~3px 8px */
  max-width: 230px; /* optional: wider box if text wraps */
}
</style>
